import React, { useState, useEffect } from "react";
import Category from "../components/Category";
import HeroSlide from "../components/HeroSlide";
import ProductSlide from "../components/ProductSlide";
import axios from "axios";
import { baseurl, imgurl } from "../baseurl"; // Ensure imgurl is imported
import CategoryMobile from "../components/CategoryMobile";
import ProductCardSlideMobile from "./HomeCompo/ProductCardSlideMobile";

function Return() {
  
    return (
     <>
     
     <section className="container my-5">
    <h1>Return & Refund Policy</h1>
    <p><strong>Subcity International Marketing Pvt Ltd</strong></p>
    <p><strong>Effective Date:</strong> 02/02/2026<br/>
    <strong>Last Updated:</strong> 02/02/2026</p>

    <p>This Return & Refund Policy applies to all purchases made on the official e-commerce website of Subcity International Marketing Pvt Ltd (“Company”, “we”, “our”, “us”).</p>

    <hr/>

    <h2>1. Eligibility for Return</h2>
    <p>A return request will be accepted only under the following conditions:</p>
    <ul>
        <li>Product received is damaged</li>
        <li>Product received is defective</li>
        <li>Product received is wrong / incorrect</li>
    </ul>
    <p>⏱ <strong>Return request must be raised within 48 hours of delivery.</strong></p>

    <h2>2. Non-Returnable Items</h2>
    <p>The following items are not eligible for return or refund:</p>
    <ul>
        <li>Products damaged due to misuse or negligence</li>
        <li>Products with tampered, missing, or damaged original packaging</li>
        <li>Used or partially consumed products</li>
        <li>Products marked as “Non-Returnable” on the product page</li>
    </ul>

    <h2>3. Return Process</h2>
    <p>To initiate a return:</p>
    <ul>
        <li>Contact us within 48 hours of delivery</li>
        <li>Share order ID, reason for return, and product images</li>
        <li>Our team will verify the request</li>
        <li>Approved returns will be picked up or returned as instructed</li>
    </ul>
    <div class="contact-info">
        <strong>📧 Email:</strong> subcityinternational22@gmail.com<br/>
        <strong>📞 Phone:</strong> 8638407127
    </div>

    <h2>4. Refund Policy</h2>
    <ul>
        <li>Refunds are processed only after return verification</li>
        <li>Refunds will be initiated within 7–10 working days after approval</li>
        <li>Refunds will be credited to the original payment method only</li>
        <li>Shipping charges (if any) are non-refundable, unless the return is due to Company error</li>
    </ul>

    <h2>5. Cancellation Policy</h2>
    <ul>
        <li>Orders can be cancelled only before dispatch</li>
        <li>Once shipped, orders cannot be cancelled</li>
        <li>Refund for cancelled orders (before dispatch) will be processed within 5–7 working days</li>
    </ul>

    <h2>6. Replacement Policy</h2>
    <ul>
        <li>Replacement may be offered instead of refund based on product availability</li>
        <li>Replacement is applicable only for damaged or incorrect products</li>
    </ul>

    <h2>7. Delayed or Failed Refunds</h2>
    <p>If you have not received your refund within the stated time:</p>
    <ul>
        <li>Check with your bank/payment provider</li>
        <li>If the issue persists, contact us with your order details</li>
    </ul>

    <h2>8. Company Rights</h2>
    <p>The Company reserves the right to:</p>
    <ul>
        <li>Reject return requests that do not meet policy conditions</li>
        <li>Modify this policy at any time as per legal or business requirements</li>
    </ul>

    <h2>9. Grievance Redressal Officer</h2>
    <p>As per Consumer Protection (E-Commerce) Rules, 2020:</p>
    <div class="contact-info">
        <strong>Grievance Officer:</strong> Md Helal Uddin<br/>
        <strong>📧 Email:</strong> subcityinternational22@gmail.com<br/>
        <strong>📞 Mobile:</strong> 8638407127
    </div>
    <p>⏱ Complaints will be acknowledged within 48 hours and resolved within 30 days.</p>

    <h2>10. Contact Information</h2>
    <div class="contact-info">
        <strong>Subcity International Marketing Pvt Ltd</strong><br/>
        📍 Address: Vill Paliguri, Jagiroad, Morigaon, Assam – 782410, India<br/>
        📞 Mobile: 8638407127<br/>
        📧 Email: subcityinternational22@gmail.com
    </div>


<style>
    {`
    <style>
        body {
            font-family: Arial, sans-serif;
            line-height: 1.6;
            color: #333;
            max-width: 800px;
            margin: 0 auto;
            padding: 20px;
        }
        h1, h2, h3 {
            color: #2c3e50;
        }
        .contact-info {
            background-color: #f9f9f9;
            padding: 15px;
            border-left: 5px solid #2c3e50;
            margin: 20px 0;
        }
        .warning {
            background-color: #fff3cd;
            padding: 10px;
            border-radius: 5px;
            display: inline-block;
        }
        ul {
            margin-bottom: 20px;
        }
    </style>
    `}
</style>
     </section>
     
     </> 
   
  );
}

export default Return;